export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/guy.776bcb26.svg","height":475,"width":778,"blurWidth":0,"blurHeight":0};